var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemEditor',{ref:"selectItem",on:{"finishedEditing":function($event){return _vm.itemFinishedEditing($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }